import {
  HttpDownloadProgressEvent,
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

export function jsonPipe<T>() {
  return (source: Observable<HttpEvent<string>>) => {
    let lastIndex = -1;

    return source.pipe(
      // We just want to capture download progress and completion
      filter(
        (ev): ev is HttpDownloadProgressEvent | HttpResponse<string> =>
          ev.type === HttpEventType.DownloadProgress || ev.type === HttpEventType.Response,
      ),
      switchMap(ev => {
        let match: RegExpExecArray | null;
        switch (ev.type) {
          case HttpEventType.DownloadProgress: {
            // Capture the last JSON segment between '\n\n's
            match = ev.partialText ? /(?:^|\n\n)([^\n]+)\n\n[^\n]*$/.exec(ev.partialText) : null;
            break;
          }

          case HttpEventType.Response: {
            // Capture the last JSON segment
            match = ev.body ? /(?:^|\n\n)([^\n]+)\n*$/.exec(ev.body) : null;
            break;
          }
        }

        // Prevent duplicates
        if (match && match.index > lastIndex) {
          lastIndex = match.index;
          const result = JSON.parse(match[1]);
          if ('$error' in result) {
            // Using an HttpErrorResponse means this can be handled by the GlobalErrorHandler
            return throwError(
              new HttpErrorResponse({ error: result.$error, status: result.$error.status }),
            );
          }

          return [result as T];
        }

        return [];
      }),
    );
  };
}
